import { hasMinimumLength } from '@/utils/resultsHelper';

const actions = {
  ADD_SOURCES_TO_REQUEST: 'ADD_SOURCES_TO_REQUEST',
  ALLOW_PMN_TRANSFERS: 'ALLOW_PMN_TRANSFERS',
  APPROVE_REQUEST: 'APPROVE_REQUEST',
  APPROVE_REQUEST_ERROR: 'APPROVE_REQUEST_ERROR',
  APPROVE_REQUEST_SUCCESS: 'APPROVE_REQUEST_SUCCESS',
  ARCHIVE_REQUESTS: 'ARCHIVE_REQUESTS',
  CLOSE_REQUEST: 'CLOSE_REQUEST',
  CLOSE_REQUESTS: 'CLOSE_REQUESTS',
  CREATE_REQUEST: 'CREATE_REQUEST',
  DELETE_REQUESTS: 'DELETE_REQUESTS',
  DESTROY_REQUESTS: 'DESTROY_REQUESTS',
  DESTROY_REQUESTS_ERROR: 'DESTROY_REQUESTS_ERROR',
  DENY_REQUEST: 'DENY_REQUEST',
  DENY_REQUEST_ERROR: 'DENY_REQUEST_ERROR',
  DENY_REQUEST_SUCCESS: 'DENY_REQUEST_SUCCESS',
  FETCH_REQUEST: 'FETCH_REQUEST',
  NEW_REQUEST_FROM_SOURCE: 'NEW_REQUEST_FROM_SOURCE',
  FETCH_REQUESTS: 'FETCH_REQUESTS',
  FETCH_WORKFLOW_FOR_REQUEST: 'FETCH_WORKFLOW_FOR_REQUEST',
  HIDE_APPROVE_REQUEST: 'HIDE_APPROVE_REQUEST',
  HIDE_ARCHIVE_REQUEST: 'HIDE_ARCHIVE_REQUEST',
  HIDE_DELETE_REQUEST: 'HIDE_DELETE_REQUEST',
  HIDE_TRANSFER_REQUEST: 'HIDE_TRANSFER_REQUEST',
  MARK_POLLING_COMPLETE: 'MARK_POLLING_COMPLETE',
  NEW_REQUEST_ERROR: 'NEW_REQUEST_ERROR',
  NEW_REQUEST_SUCCESS: 'NEW_REQUEST_SUCCESS',
  POLL_REQUEST: 'POLL_REQUEST',
  REFRESH_REQUESTS: 'REFRESH_REQUESTS',
  REMOVE_REQUEST_STEPS: 'REMOVE_REQUEST_STEPS',
  SHOW_APPROVE_REQUEST: 'SHOW_APPROVE_REQUEST',
  SHOW_ARCHIVE_REQUEST: 'SHOW_ARCHIVE_REQUEST',
  SHOW_ARCHIVE_REQUESTS: 'SHOW_ARCHIVE_REQUESTS',
  SHOW_CLONE_REQUEST: 'SHOW_CLONE_REQUEST',
  SHOW_DELETE_REQUEST: 'SHOW_DELETE_REQUEST',
  SHOW_DELETE_REQUESTS: 'SHOW_DELETE_REQUESTS',
  SHOW_REQUEST: 'SHOW_REQUEST',
  SHOW_REQUEST_ERROR: 'SHOW_REQUEST_ERROR',
  SHOW_REQUEST_SOURCE_ERROR: 'SHOW_REQUEST_SOURCE_ERROR',
  SHOW_REQUEST_WORKFLOW_STATUS: 'SHOW_REQUEST_WORKFLOW_STATUS',
  SHOW_REQUEST_WORKFLOW_STATUS_ERROR: 'SHOW_REQUEST_WORKFLOW_STATUS_ERROR',
  SHOW_REQUESTS_ERROR: 'SHOW_REQUESTS_ERROR',
  SHOW_REQUESTS_RESULTS: 'SHOW_REQUESTS_RESULTS',
  SHOW_TRANSFER_REQUEST: 'SHOW_TRANSFER_REQUEST',
  SHOW_WORKFLOW_FOR_REQUEST: 'SHOW_WORKFLOW_FOR_REQUEST',
  SHOW_WORKFLOW_REQUEST_ERROR: 'SHOW_WORKFLOW_REQUEST_ERROR',
  TOGGLE_REQUEST_COLUMN_ORDER_BY: 'TOGGLE_REQUEST_COLUMN_ORDER_BY',
  TOGGLE_REQUEST_SELECTED: 'TOGGLE_REQUEST_SELECTED',
  TOGGLE_REQUEST_SINGLE_SORTING: 'TOGGLE_REQUEST_SINGLE_SORTING',
  TOGGLE_REQUESTS_PRESENTATION: 'TOGGLE_REQUESTS_PRESENTATION',
  TOGGLE_REQUESTS_SELECTED: 'TOGGLE_REQUESTS_SELECTED',
  TRANSFER_REQUEST: 'TRANSFER_REQUEST',
  TRANSFER_REQUEST_ERROR: 'TRANSFER_REQUEST_ERROR',
  TRANSFER_REQUEST_SUCCESS: 'TRANSFER_REQUEST_SUCCESS',
  UPDATE_REQUEST_FIELDS: 'UPDATE_REQUEST_FIELDS',
  UPDATE_REQUEST_FIELDS_PROPERTIES: 'UPDATE_REQUEST_FIELDS_PROPERTIES',
  UPDATE_REQUEST_PROPERTIES: 'UPDATE_REQUEST_PROPERTIES',
  UPDATE_REQUEST_SOURCE: 'UPDATE_REQUEST_SOURCE',
  UPDATE_REQUEST_TRANSFER_TYPE: 'UPDATE_REQUEST_TRANSFER_TYPE',
  UPDATE_REQUESTS_FILTER: 'UPDATE_REQUESTS_FILTER',
  UPDATE_REQUESTS_FLAGS: 'UPDATE_REQUESTS_FLAGS',
  UPDATE_STEP: 'UPDATE_STEP',
  UPDATE_REQUEST_PANELS: 'UPDATE_REQUEST_PANELS',
};

export const requestLists = ['all', 'review'];

export const requestCategories = [
  ...requestLists,
  'open',
  'approval',
  'deletion',
  'archival',
  'transfer',
];

export const approvedOrDenied = {
  APPROVE: 'approved',
  DENY: 'denied',
};

export const approvalStatus = {
  ...approvedOrDenied,
  PENDING: 'pending',
  ERROR: 'error',
  NONE: null,
};

export const requestTransferTypes = {
  CLEAR: 'clear',
  PMN: 'pseudonymised',
  MANUAL: 'manual',
  TOKEN: 'token',
};

export const requestSources = {
  DATASET: 'dataset',
  COHORT: 'cohort',
};

export const requestSourceEntities = {
  ...requestSources,
  REQUEST: 'request',
};

const requestFormSteps = {
  PROJECT: { name: 'project', icon: 'inbox', isSection: true },
  ABOUT: { name: 'about', icon: 'info', isSection: true },
};

export const requestSteps = {
  SOURCE: { name: 'select_data_source', icon: 'database' },
  DESTINATION: { name: 'destination', icon: 'cubes' },
  WORKSPACE: { name: 'workspace', icon: 'cube' },
  ATTACHMENTS: { name: 'attachments', icon: 'file' },
  ...requestFormSteps,
  COMPLETE: { name: 'complete', icon: 'hourglass start' },
};

const requestIcons = {
  approved: { icon: 'thumbs up', color: 'approved' },
  blocked: { icon: 'ban', color: 'warning' },
  denied: { icon: 'thumbs down', color: 'denied' },
  error: { icon: 'times circle', color: 'error' },
  'manual.ready': { icon: 'checkmark', color: 'approved' },
  pending: { icon: 'clock', color: 'pending' },
  ready: { icon: 'exchange', color: 'approved' },
  transferred: { icon: 'exchange', color: 'approved' },
};

const requestTransferrableIcon = (requester, transfer) => {
  if (!requester.active) { return 'blocked'; }
  if (transfer.transfer_type === requestTransferTypes.MANUAL) { return 'manual.ready'; }
  return 'ready';
};

export const requestIcon = ({ requester, status, transfer }, allowTransfer) => {
  let icon = hasMinimumLength(transfer?.transferred_at) ? 'transferred' : status;

  if (allowTransfer) {
    icon = requestTransferrableIcon(requester, transfer);
  }

  return { ...requestIcons[icon], message: `status.${icon}`, verbose: `status.${icon}.verbose` };
};

export const pollingStatus = {
  APPROVED: 'approved',
  CREATED: 'created',
  DELAYED: 'delayed',
  ERRORED: 'errored',
  POLLING: 'polling',
  NONE: 'none',
};

export const successfulPollingStatuses = [pollingStatus.APPROVED, pollingStatus.CREATED, pollingStatus.DELAYED];

export const REQUEST_SUGGESTIONS = ['name', 'project', 'dataset', 'workspace'];

export const REQUEST_REVIEW_SUGGESTIONS = [...REQUEST_SUGGESTIONS, 'requester'];

export default actions;
